import script from "./ContactUsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUsComponent.vue?vue&type=style&index=0&id=e37ef66e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37ef66e"]])

export default __exports__